'use strict';

angular
	.module('PinMeTo.services')
	.service('pmtSiteInfoService', function (pmtSiteService, pmtEnvService) {
		let siteInfo = {
			work: {},
			notifications: []
		};

		let sitePromise = pmtSiteService.getSite();

		let subscribers = {};
		function subscribe(key, callback) {
			if (!subscribers[key]) {
				subscribers[key] = [];
			}
			subscribers[key].push(callback);
		}
		function sendMessage(key, msg) {
			if (subscribers[key]) {
				subscribers[key].forEach(function (subscriber) {
					subscriber(msg);
				});
			}
		}

		function sendNotifications() {
			sendMessage('Notifications', siteInfo.notifications);
		}
		function sendWork() {
			sendMessage('Work', siteInfo.work);
		}

		this.addWork = () => {
			siteInfo.work.inProgress = siteInfo.work.inProgress ? siteInfo.work.inProgress + 1 : 1;
			sendWork();
		};

		this.subscribeToNotifications = callback => {
			subscribe('Notifications', callback);
			sendNotifications();
		};

		this.subscribeToWork = callback => {
			subscribe('Work', callback);
			sendWork();
		};

		let createWebsocket = function () {
			sitePromise.then(function (site) {
				if (!site) {return;}

				let baseUrl = pmtEnvService.listingsManagerUrl
					.replace('https', 'wss')
					.replace('http', 'ws')
					.replace('/listings/', '/');
				let socketUrl = baseUrl + 'info';

				let work = io.connect(socketUrl, {
					query: 'site=' + site.name,
					transports: ['websocket'],
					path: '/listings/socket.io'
				});

				work.on('work', function (data) {
					siteInfo.work = data;
					sendWork();
				});

				work.on('notifications', function (data) {
					if (site.name === data.siteName) {
						siteInfo.notifications = data.notifications;
						sendNotifications();
					}
				});

				work.on('listenRespond', (/*data*/) => {});
			});
		};

		createWebsocket();
	});
